import { FC } from 'react'
import { MiteneIconBase, MiteneIconProps } from './MiteneIconBase'

export const MiteneLogo: FC<MiteneIconProps> = (props) => {
  return (
    <MiteneIconBase viewBox='0 0 36 21' {...props}>
      <polygon fill='#FF8FAD' points='9 0 0 8.02385007 0 20.34 9 12.3161499' />
      <polygon fill='#FF8352' points='27 0 27 12.3152655 36 20.34 36 8.02385007' />
      <polygon fill='#FFC654' points='27 0 18 8.02385007 18 20.34 27 12.3161499' />
      <polygon fill='#31C9F3' points='9 0 9 12.3161499 18 20.34 18 8.02385007' />
    </MiteneIconBase >
  )
}
